import store from '../store/index'

export default function authMiddleware({ next, router }) {
    let logged_in = store.getters['authModule/IsLoggedIn'];
    if (logged_in) {
        return router.push({ name: 'Home' });
    }
    return next();
}